<template>
  <div>
    <div style="display: flex">
      <div class="rule-info">
        <span class="info-label">项目</span>
        <div class="info-content">
          <el-select v-model="ruleInfo.itemType" style="width: 156px" @change="ruleInfoInit">
            <el-option :value="1" :disabled="disabled" :label="isPrice ? '增加出价' : '增加预算'"></el-option>
            <el-option :value="2" :disabled="disabled" :label="isPrice ? '设置新出价' : '设置新预算'"></el-option>
            <el-option :value="3" :disabled="disabled" :label="isPrice ? '减少出价' : '减少预算'"></el-option>
          </el-select>
        </div>
      </div>
      <span>&emsp;</span>
      <div class="rule-info">
        <el-input v-model="ruleInfo.value" @blur="toFloat('value', ruleInfo, true)">
          <el-select v-model="ruleInfo.valueType" slot="append" style="width: 62px">
            <el-option :value="1" label="元"></el-option>
            <el-option :value="2" :disabled="ruleInfo.itemType === 2" label="%"></el-option>
          </el-select>
        </el-input>
      </div>
    </div>

    <div style="display: flex">
      <div class="rule-info">
        <span class="info-label">频次</span>
        <div class="info-content">
          <el-select v-model="ruleInfo.frequencyTotal" style="width: 74px">
            <el-option :value="1" label="1次"></el-option>
            <el-option :value="2" label="2次"></el-option>
            <el-option :value="3" label="3次"></el-option>
            <el-option :value="4" label="4次"></el-option>
            <el-option :value="5" label="5次"></el-option>
          </el-select>

          <el-select v-model="ruleInfo.frequencyType" style="width: 74px; margin-left: 8px">
            <el-option :value="1" label="每天"></el-option>
            <el-option :value="2" label="总共"></el-option>
          </el-select>
        </div>
      </div>

      <span>&emsp;</span>

      <div class="rule-info">
        <span class="info-label">{{ ruleInfo.itemType === 3 ? '下限' : '上限' }}</span>
        <div class="info-content">
          <el-input v-model="ruleInfo.upperLimit" style="width: 120px" @blur="toFloat('upperLimit', ruleInfo, true)" />
          <span style="display: inline-block; margin-left: 12px">元</span>
        </div>
      </div>
    </div>

    <div><span style="font-size: 12px; color: orange">注意：频次（每天/总共）发生修改时，频次重新开始计数</span></div>
  </div>
</template>

<script>
import { isEmpty } from '@/common/js/utils'
import { mul, div } from '@/common/js/api'

export default {
  name: 'RuleConfig',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: Number,
      default: 3
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ruleInfo: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    isPrice() {
      return this.type === 4
    }
  },
  methods: {
    ruleInfoInit() {
      this.ruleInfo = Object.assign(this.ruleInfo, {
        value: '',
        valueType: 1,
        frequencyTotal: 1,
        frequencyType: 1,
        upperLimit: ''
      })
    },
    toFloat(key, obj, fixed) {
      if (isEmpty(obj[key])) return
      let val = parseFloat(obj[key])
      if (val < 0) val = 0
      else if (fixed) {
        val = mul(val, 100)
        val = div(Math.floor(val), 100)
      }
      obj[key] = String(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.rule-info {
  height: 32px;
  min-width: 168px;
  margin-bottom: 12px;
  display: flex;

  .info-label {
    line-height: 32px;
    width: 36px;
    flex: 0 0 36px;
  }

  .info-content {
    flex: 0 0 auto;
  }
}
</style>
